import { LanguageCode } from '@/ifaces/language';
import { Entitlements } from '@/ifaces/entitlements';

export enum CustomEventNames {
  ChangeLanguageCode = 'changeLanguageCode',
  HideLanguageSwitcher = 'hideLanguageSwitcher',
  ShowLanguageSwitcher = 'showLanguageSwitcher',
  ShowPromoFooter = 'showPromoFooter',
  SetEntitlements = 'setEntitlements',
  SetProgramSlug = 'setProgramSlug',
}

export type LanguageCodeChangeEvent = CustomEvent<{
  languageCode: LanguageCode;
}>;
export function createLanguageCodeChangeEvent(languageCode: LanguageCode) {
  return new CustomEvent(CustomEventNames.ChangeLanguageCode, {
    detail: { languageCode },
  });
}
export function triggerLanguageCodeChangeEvent(languageCode: LanguageCode) {
  window.dispatchEvent(createLanguageCodeChangeEvent(languageCode));
}

export type LanguageCodeHideEvent = CustomEvent<object>;
export function createHideLanguageSwitcherEvent() {
  return new CustomEvent(CustomEventNames.HideLanguageSwitcher);
}
export function triggerHideLanguageSwitcherEvent() {
  window.dispatchEvent(createHideLanguageSwitcherEvent());
}

export type LanguageCodeShowEvent = CustomEvent<object>;
export function createShowLanguageSwitcherEvent() {
  return new CustomEvent(CustomEventNames.ShowLanguageSwitcher);
}
export function triggerShowLanguageSwitcherEvent() {
  window.dispatchEvent(createShowLanguageSwitcherEvent());
}

export type ShowPromoFooterEvent = CustomEvent<{ promoUrl: string }>;
export function createShowPromoFooterEvent(promoUrl: string) {
  return new CustomEvent(CustomEventNames.ShowPromoFooter, {
    detail: { promoUrl },
  });
}
export function triggerShowPromoFooterEvent(promoUrl: string) {
  window.dispatchEvent(createShowPromoFooterEvent(promoUrl));
}

export type SetEntitlementsEvent = CustomEvent<{ entitlements: Entitlements }>;
export function createSetEntitlementsEvent(entitlements: Entitlements) {
  return new CustomEvent(CustomEventNames.SetEntitlements, {
    detail: { entitlements },
  });
}
export function triggerSetEntitlementsEvent(entitlements: Entitlements) {
  window.dispatchEvent(createSetEntitlementsEvent(entitlements));
}
